export default "__VITE_PUBLIC_ASSET__3a29e98c__"